const initStatCardCounters = () => {
	const counters = document.querySelectorAll('.block-card-stats .number');

	if (!counters.length) return;

	const isVisible = (el) => {
		const rect = el.getBoundingClientRect();
		return rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
	};

	const countUp = (el) => {
		if (el.dataset.counterInitialized === 'true') {
			return;
		}
		el.dataset.counterInitialized = 'true';

		const raw = el.dataset.number || '';
		const trimmed = raw.trim();

		// Keep ONLY a leading "$" as prefix
		const prefix = trimmed.startsWith('$') ? '$' : '';

		// Numeric target
		const target = parseInt(trimmed.replace(/[^\d]/g, ''), 10);

		if (Number.isNaN(target)) {
			el.textContent = raw;
			return;
		}

		const suffix = trimmed.replace(/^\$/, '').replace(/[\d,]/g, '');

		// Swap the server-rendered final value for the animation start point. This
		// happens at intersection time, so it is never painted at the final value
		// and then visibly reset.
		el.textContent = prefix + '0' + suffix;

		// Set animation duration
		const duration = 1200;
		const steps = 40;
		const increment = Math.max(Math.ceil(target / steps), 1);
		let count = 0;

		const interval = setInterval(() => {
			count += increment;

			// Stop animation at target number
			if (count >= target) {
				count = target;
				clearInterval(interval);
			}
			el.textContent = prefix + count.toLocaleString() + suffix;
		}, duration / steps);
	};

	if (!('IntersectionObserver' in window)) {
		counters.forEach(countUp);
		return;
	}

	// Animate when the element is meaningfully visible. A 100% threshold is too
	// brittle inside sliders, clipped wrappers, sticky headers, and admin bars.
	const observer = new IntersectionObserver((entries, obs) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				countUp(entry.target);
				obs.unobserve(entry.target);
			}
		});
	}, { threshold: 0.25 });

	counters.forEach(el => {
		observer.observe(el);

		// Safety net for browsers/plugins/layout states where IntersectionObserver
		// does not report after the script is loaded.
		setTimeout(() => {
			if (isVisible(el)) {
				countUp(el);
				observer.unobserve(el);
			}
		}, 1500);
	});
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initStatCardCounters);
} else {
	initStatCardCounters();
}
